<div *ngIf="isLoading" class="spinner">
  <div class="lds-ring-xl"></div>
</div>
<div *ngIf="!isLoading">
  <router-outlet></router-outlet>
</div>
